export default {
  effects: {
    captions: {
      blur: 'Размытие',
      crop: 'Обрезка',
      enhance: 'Улучшение',
      flip: 'Отразить по вертикали',
      grayscale: 'Оттенки серого',
      invert: 'Инвертировать',
      mirror: 'Отразить по горизонтали',
      rotate: 'Повернуть',
      sharp: 'Резкость',
    },
    apply: 'Применить',
  },
}
